// extracted by mini-css-extract-plugin
export var image = "Integrations-module--image--6b8a4";
export var typography = "Integrations-module--typography--559f6";